import { TriangleAlert } from 'components/icons';
import type { ReactNode } from 'react';
import { cn } from 'utils/cn';

/** A warning on a setting: what switching it does, or why it should stay on for the whole firm. */
export function SettingCaution({
    text,
    className,
    icon = <TriangleAlert className="mt-0.5 size-3.5" />,
}: {
    text: string;
    className?: string;
    icon?: ReactNode;
}) {
    return (
        <div
            className={cn(
                'bg-caution text-caution-ink new:bg-warning-tint new:text-warning-ink flex items-start gap-2 rounded-md px-2.5 py-[7px] text-xs leading-[18px]',
                className
            )}
        >
            {icon}
            <span>{text}</span>
        </div>
    );
}
